import "../../bdoStyling/bdostyling.css";
import { Button, message } from "antd";
import { exportToExcel } from "../../utils/exportToExcel";
import { getMeetingRoomsData } from "../../api/meeting-rooms/getMeetingRoomsData";
import { GlobalContext } from "../../components/layout/global-context/globalContext";
import { TransformedDataType } from "../../api/numbers/getSipMeetingRoomAssignments";
import { useContext, useState } from "react";
import AddMeetingRoomDlFormModal from "./add-meeting-room-dl-form-modal/AddMeetingRoomDlFormModal";
import AddMeetingRoomFormModal from "./add-meeting-room-form-modal/AddMeetingRoomFormModal";
import TablePage from "../../components/table-page/TablePage";
import { AiOutlineFileExcel } from "react-icons/ai";

interface State {
  isAddMeetingRoomModalVisible: boolean;
  isAddMeetingRoomDlModalVisible: boolean;
  dataView: TransformedDataType[];
  refreshDataToggle: boolean;
}

function MeetingRooms() {
  const { user } = useContext(GlobalContext);
  const [state, setState] = useState<State>({
    isAddMeetingRoomModalVisible: false,
    isAddMeetingRoomDlModalVisible: false,
    dataView: [] as TransformedDataType[],
    refreshDataToggle: true,
  });
  const {
    isAddMeetingRoomModalVisible,
    isAddMeetingRoomDlModalVisible,
    dataView,
    refreshDataToggle,
  } = state;

  const [messageApi, contextHolder] = message.useMessage();

  const buttons = [
    {
      title: "Add Meeting Room",
      visible: user.isAdmin,
      onClick: () => {
        setState((prevState) => ({
          ...prevState,
          isAddMeetingRoomModalVisible: true,
        }));
      },
    },
    {
      title: "Add DL",
      visible: user.isAdmin,
      onClick: () => {
        setState((prevState) => ({
          ...prevState,
          isAddMeetingRoomDlModalVisible: true,
        }));
      },
    },
    {
      title: (
        <span className="flex">
          <AiOutlineFileExcel className="text-lg mr-1" />
          Export
        </span>
      ),
      visible: true,
      onClick: () => {
        exportToExcel(dataView, "Export-MeetingRooms", {
          // id: { displayAs: "ID", colWidth: 4 },
          phoneNumber: { displayAs: "Phone Number", colWidth: 14 },
          name: { displayAs: "Room Name", colWidth: 24 },
        });
      },
    },
  ];

  return (
    <div className="flex flex-col w-full">
      {contextHolder}
      <div className="flex justify-between items-center mx-8 my-6">
        <h1 className="text-lg font-semibold text-bdo-text-01-charcoal">
          Meeting Rooms
        </h1>
        <aside className="flex gap-3">
          {buttons.map((button, index) => {
            return (
              button.visible && (
                <Button
                  key={index}
                  onClick={button.onClick}
                  className="bdo-red-button"
                >
                  {button.title}
                </Button>
              )
            );
          })}
        </aside>
      </div>

      <div className="flex-row w-full">
        <TablePage
          refreshDataToggle={refreshDataToggle}
          setParentDataView={(data) => {
            setState((prevState) => ({
              ...prevState,
              dataView: data,
            }));
          }}
          pageConfiguration={{
            pageName: "Meeting Rooms",
            dataApi: getMeetingRoomsData,
            columnDefinitions: [
              { titleText: "Number", dataIndex: "phoneNumberX" },
              { titleText: "Room Name", dataIndex: "name" },
            ],
          }}
        />

        <AddMeetingRoomFormModal
          isVisible={isAddMeetingRoomModalVisible}
          handleClose={(refreshData) => {
            setState((prevState) => ({
              ...prevState,
              isAddMeetingRoomModalVisible: false,
              ...(refreshData ? { refreshDataToggle: !refreshDataToggle } : {}),
            }));
          }}
        />
        <AddMeetingRoomDlFormModal
          isVisible={isAddMeetingRoomDlModalVisible}
          handleClose={(refreshData) => {
            if (refreshData) {
              messageApi.open({
                type: "success",
                content:
                  "Newly added Meeting Room DL will take effect after Orchestrator sync.",
                duration: 10,
              });
            }
            setState((prevState) => ({
              ...prevState,
              isAddMeetingRoomDlModalVisible: false,
              ...(refreshData ? { refreshDataToggle: !refreshDataToggle } : {}),
            }));
          }}
        />
      </div>
    </div>
  );
}

export default MeetingRooms;
